import clsx from 'clsx';

import { FieldHeader } from '@/App/tiles/Option/strategy/FieldHeader.tsx';
import { getFieldSpan } from '@/App/tiles/Option/strategy/strategyLayout.ts';
import type { StrategyFields, StrategyOrientation } from '@/App/tiles/Option/strategy/types.ts';

type StrategyFieldHeadersProps = {
  tileId: string;
  fields: StrategyFields;
  mode: StrategyOrientation;
};

export function StrategyFieldHeaders({ tileId, fields, mode }: StrategyFieldHeadersProps) {
  const displayedFields = mode === 'horizontal' ? fields.flat() : fields;

  return displayedFields.map((fieldOrGroup) => {
    if (!Array.isArray(fieldOrGroup)) {
      return <FieldHeader key={fieldOrGroup} field={fieldOrGroup} tileId={tileId} />;
    }

    return (
      <div
        key={`group-${fieldOrGroup[0]}`}
        style={{ gridRowEnd: `span ${getFieldSpan(fieldOrGroup)}` }}
        className={clsx('fieldGroup header', { 'pricing-fields': fieldOrGroup.includes('premium') })}
      >
        {fieldOrGroup.map((field) => (
          <FieldHeader key={field} field={field} tileId={tileId} />
        ))}
      </div>
    );
  });
}
